const LOG_PREFIX = "[OCM][PageSense] "
window.ocm_observer = null

let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let subPaths = window.location.pathname.replace("/", "").split("/") || [];
    let customPaths = ["archeio", "profil", "about", "ori-chrisis", "diafimisi", "syndesmi", "sitemap"];
    // Keep only String values in subPaths (removes null and empty)
    subPaths = subPaths.filter(String);
    // The actual page sense goes here
    if (subPaths.length === 0) {
      pageType = "Home";
    } else if (subPaths.length === 1) {
      if (customPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Custom-1";
      } else {
        pageType = "Article";
      }
    } else if (subPaths.length >= 2 && subPaths[0] === "category") {
      pageType = "Category";
    }

    let googletag = window.googletag || {cmd:[]};
    googletag.cmd.push(function() {

      //            var inline1 = googletag.sizeMapping()
      //                 .addSize([0, 0], [[300, 250], [300, 600]])
      //                 .addSize([340, 0], [[300, 250], [336, 280], [300, 600]])
      //                 .addSize([768, 0], [[300, 250], [336, 280]])
      //                 .addSize([1024, 0], [[300, 250], [336, 280]])
      //                 .build();

      //             var inline2 = googletag.sizeMapping()
      //                 .addSize([0, 0], [[300, 250]])
      //                 .addSize([340, 0], [[300, 250], [336, 280]])
      //                 .addSize([768, 0], [[300, 250], [336, 280]])
      //                 .addSize([1024, 0], [[300, 250], [336, 280]])
      //                 .build();

      //             if (pageType==="Article") {
      //                   googletag.defineSlot('/75351959,21673590828/agrinionews.gr/inline1', [[300, 250], [336, 280], [300, 600]], 'inline1').defineSizeMapping(inline1).addService(googletag.pubads());
      //                   googletag.defineSlot('/75351959,21673590828/agrinionews.gr/inline2', [[300, 250], [336, 280], [300, 600]], 'inline2').defineSizeMapping(inline1).addService(googletag.pubads());
      //                   googletag.defineSlot('/75351959,21673590828/agrinionews.gr/inline3', [[300, 250], [336, 280]], 'inline3').defineSizeMapping(inline2).addService(googletag.pubads());
      //             }
    })
    utils.loadStyle('.fixed_wrap {overflow:inherit!important;} .no-bnmenu .breaking-cont {width: 100%}')
    resolve(pageType)
  });
};
module.exports = pageSense;